import { AxiosInstance } from "axios"
import { BillReceiver, UpdateBillReceiverPayload } from "./settingsTypes"

export enum UserSettingsQuery {
    BILL_RECEIVERS = "user-settings-bill-receivers",
    BILL_RECEIVER_DETAILS = "user-settings-bill-receiver-details",
}

// Fetch bill receivers
export type FetchBillReceiversParams = Readonly<{
    userId: number
    search?: string
}>

export type FetchBillReceiversResponse = Readonly<{
    billReceivers: BillReceiver[]
}>

export async function fetchBillReceivers(
    { userId, search }: FetchBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchBillReceiversResponse> {
    const params = search ? { search } : {}
    const response = await axios.get<FetchBillReceiversResponse>(
        `/users/${userId}/payment/personalBillReceivers`,
        { params, signal },
    )
    return response.data
}

// Fetch bill receiver by ID
export type FetchBillReceiverByIdParams = Readonly<{
    billReceiverId: number
}>

export type FetchBillReceiverByIdResponse = Readonly<{
    billReceiver: BillReceiver
}>

export async function fetchBillReceiverById(
    { billReceiverId }: FetchBillReceiverByIdParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchBillReceiverByIdResponse> {
    const url =  `/billReceivers/${billReceiverId}`
    const response = await axios.get(
        url,
        { signal },
    )
    return response.data
}

// Update bill receiver
export type UpdateBillReceiverParams = Readonly<{
    billReceiverId: number
    payload: UpdateBillReceiverPayload
}>

export type UpdateBillReceiverResponse = Readonly<{
    serviceResponse: {
        displayMessage: string
    }
}>

export async function updateBillReceiver(
    { billReceiverId, payload }: UpdateBillReceiverParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UpdateBillReceiverResponse> {
    const response = await axios.put<UpdateBillReceiverResponse>(
        `/billReceivers/${billReceiverId}`,
        payload,
        { signal },
    )
    return response.data
}

// Delete bill receiver
export type DeleteBillReceiverParams = Readonly<{
    userId: number
    billReceiverId: number
}>

export type DeleteBillReceiverResponse = Readonly<{
    serviceResponse: {
        displayMessage: string
    }
}>

export async function deleteBillReceiver(
    { userId, billReceiverId }: DeleteBillReceiverParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeleteBillReceiverResponse> {
    const response = await axios.delete<DeleteBillReceiverResponse>(
        `/users/${userId}/payment/billReceivers/${billReceiverId}`,
        { signal },
    )
    return response.data
}
